import axios from 'axios';
import { REFRESH_API_PATH } from 'constants/api';
import authService from '../shared/service/authService';

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken');
  if (config.url!.includes('s3')) return config;

  // ODX Admin API 호출은 인터셉터 제외
  if (config.url?.includes(process.env.REACT_APP_ODX_ADMIN_BASE_URL || '')) {
    return config;
  }

  config.withCredentials = true;
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  async response => {
    return response;
  },
  async error => {
    const originalRequest = error.config;
    if (!error.response) {
      throw error;
    }

    if (error.response.status === 401) {
      originalRequest._retry = true;
      if (!(originalRequest.url as string).includes(REFRESH_API_PATH)) {
        try {
          const refreshResponse = await authService.refreshToken();
          localStorage.setItem('authToken', refreshResponse.access);
          return axios(originalRequest);
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (refreshError) {
          await authService.clearAuthInfo();
          window.location.href = '/login';
        }
      }
      await authService.clearAuthInfo();
      window.location.href = '/login';
    } else if (error.response.status === 400) {
      // 400 에러는 개별 컴포넌트에서 처리하도록 하지 않음
      // interceptor에서 메시지를 표시하지 않고 throw만 함
      // 각 컴포넌트에서 필요한 경우 에러 메시지를 처리
      throw error;
    }
    throw error;
  }
);
